import { render, staticRenderFns } from "./SectionGeneral.vue?vue&type=template&id=10b396a0"
import script from "./SectionGeneral.vue?vue&type=script&lang=ts"
export * from "./SectionGeneral.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports